import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
// import { ModalGiaHan } from "./ModalGiaHan";

export const BtnChiTietHopDong = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} className="blue btn-link" onClick={handleShow}>
        {item.Code}
      </a>
      {show && (
        <ChiTietHopDongContainer
          show={show}
          onHide={handleClose}
          data={item}
        />
      )}
    </>
  );
};
